import React, { useEffect, useState } from "react";
import { getSyncTablePreview } from "../services/metricsApi";

const formatTimestamp = (value) => {
  if (value === undefined || value === null || value === "") return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return `${date.toLocaleString("en-GB", {
    dateStyle: "medium",
    timeStyle: "short",
    hour12: true,
  })} UTC`;
};

const LastRefreshed = ({ table }) => {
  const [refreshInfo, setRefreshInfo] = useState({ status: "loading", timestamp: null, error: null });

  useEffect(() => {
    let cancelled = false;

    const fetchLastRefreshed = async () => {
      try {
        const response = await getSyncTablePreview(table);
        const rows = Array.isArray(response?.data) ? response.data : [];
        const timestamp = formatTimestamp(rows[0]?.last_updated_at);
        if (!cancelled) {
          setRefreshInfo({ status: timestamp ? "ready" : "missing", timestamp, error: null });
        }
      } catch (error) {
        console.error(`Error fetching ${table} last refreshed timestamp:`, error);
        const message = error instanceof Error ? error.message : "Request failed";
        if (!cancelled) setRefreshInfo({ status: "error", timestamp: null, error: message });
      }
    };

    fetchLastRefreshed();
    return () => {
      cancelled = true;
    };
  }, [table]);

  const failedStatus = refreshInfo.error?.match(/failed:\s*(\d{3})/i)?.[1];
  const value = refreshInfo.status === "loading"
    ? "Loading..."
    : refreshInfo.status === "error"
      ? `Unavailable${failedStatus ? ` (${failedStatus})` : ""}`
      : refreshInfo.timestamp || "Not available";

  return (
    <span
      aria-live="polite"
      title={refreshInfo.error || undefined}
      style={{
        color: "var(--an-text, #1a1a1a)",
        fontSize: "0.8125rem",
        marginRight: "1rem",
        whiteSpace: "nowrap",
      }}
    >
      Last refreshed: {value}
    </span>
  );
};

export default LastRefreshed;
